// Landing hero promise and 3-step strip. No prices, no em dashes.
export const HOME_HERO_PROMISE =
  "Free to compare trip options. Pay only for the full day-by-day itinerary you choose.";

export const HOME_STEPS = [
  "Tell Dople how you travel",
  "Compare trip options free",
  "Unlock the full day-by-day plan",
];

export const HOME_SAMPLE_PATH = "/samples/lisbon-food-and-pace";

// landing_hero variant sample_preview. Leads with a sample itinerary.
export const HOME_SAMPLE_PREVIEW = {
  kicker: "Sample itinerary",
  title: "Lisbon, food first, easy pace",
  note: "An example of the day-by-day plan. Not a booking, and not your trip yet.",
  days: [
    { label: "Day 1", text: "Arrive, coffee near the hotel, and an early dinner." },
    { label: "Day 2", text: "A market morning and one viewpoint, then seafood close by." },
    { label: "Day 3", text: "Alfama at a walking pace, with a cafe break and a short ride back." },
  ],
  headline: "This is the kind of trip Dople builds.",
  subtitle: "Yours follows how you travel, eat, and spend a day. The sample is only the shape.",
};
